import { XdrSearchGzDataProvider } from '../dataProvider/XdrSearchGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class XdrSearchDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, XdrSearchGzDataProvider);
  }
}
